import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleEditModal, toggleNeedRefresh, setModalViewActualTab } from '../../store/userTabSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';

import Spinner from '../../components/components/spinner/spinner.jsx';



import { ReactComponent as StarFilled } from '../../components/icons/star-filled.svg';
import { ReactComponent as StarEmpty } from '../../components/icons/star-empty.svg';

import {
    getHeaders,
    headerWidthsForUserOpinions,
    tabsConfig,
    buttonsConfig,
    leftSideConfig,
    rightSideConfig,
    empty,
} from './userOpinionsTableConfig.js';


import './User.css';
import apiService from "../../components/api_services/apiService";
import Table from "../../components/list2/table";
import {headerWidths} from "./userTableConfig";
import customText from "../../components/components/custom_text/customText";
import UniversalLineWithComponents
    from "../../components/components/universal_line_with_components/universalLineWithComponents";
import CustomText from "../../components/components/custom_text/customText";


function ViewUser() {
  const dispatch = useDispatch();

  const isModalOpen = useSelector((state) => state.users.editModalOpen);
  const modalViewActualTab = useSelector((state) => state.users.modalViewActualTab);
  const viewedUser = useSelector((state) => state.users.viewedUser);

  const modalViewTabs = [
      "Dane podstawowe",
      "Statystyki"
  ]

  const [refresh, setRefresh] = useState(false);


  const [formData, setFormData] = useState({

    //first
    id: '',
    first_name: '',
    createdAt: '',
    email: '',
    phoneNumber: '',
    password: '***********',
    role: '',// NEW
      lastLogin: '',

    //second
    sex: '',
    gpsPoint: '',
    yearOfBirth: '',
    profilePhoto: '',
    otherPhotos: [],

    //third
    mostPracticedSport:'',
    otherSports: [
    ],

    //fourth
    avgScore: 0,
    numberOfOpinions: 1263,
    opinions: [{
      id:1,
      addingDate:'',
      senderUserName:'',
      senderUserId:'',
      avgScore:1,
      actions:''
    },
    ],

    //fifth
    payments: [],

  });

    const [blocked, setBlocked] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // Stan loadera

    const [userStats, setUserStats] = useState(null);
    const [statsLoading, setStatsLoading] = useState(false);
    const [statsError, setStatsError] = useState(null);

    const handleZablokujOblokuj = () => {
        setIsLoading(true); // Włącz loader
        try {
            ApiService.toggleHasBlocked(viewedUser);
            dispatch(toggleNeedRefresh());
            setRefresh(!refresh);
        } catch (error) {
            console.error('Błąd podczas blokowania/odblokowywania:', error);
        } finally {
            setIsLoading(false); // Wyłącz loader
        }

    }

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    // Dodaj useEffect, który zaktualizuje formData gdy viewedUser się zmieni
    useEffect(() => {

        setIsLoading(true); // Włącz loader na początku

        if (viewedUser) {
            // Pobierz dane użytkownika
            const fetchUserData = async () => {
                try {
                    // Pobierz dane użytkownika
                    const responseData = await ApiService.getUserData(viewedUser);
                    console.log('Otrzymane dane z API:', responseData);
                    console.log('Role from API - responseData.role:', responseData.role);
                    console.log('Role from API - responseData.profile?.role:', responseData.profile?.role);
                    console.log('Role from API - responseData.user?.role:', responseData.user?.role);
                    console.log('Full responseData structure:', JSON.stringify(responseData, null, 2));
                    
                    // Extract role from multiple possible locations and normalize to uppercase
                    // Check various possible locations in the response
                    let userRole = responseData.role || 
                                   responseData.profile?.role || 
                                   responseData.user?.role || 
                                   responseData.authorities?.[0]?.authority ||
                                   responseData.authorities?.[0] ||
                                   (responseData.authorities && responseData.authorities.length > 0 ? responseData.authorities[0] : null) ||
                                   null;
                    
                    // If role is still not found, try to get it from the users list endpoint as fallback
                    // The table view uses getUsers() where role is at index [4]
                    if (!userRole || userRole === 'USER') {
                        console.log('Role not found or defaulting to USER, trying to fetch from users list...');
                        try {
                            // Search through multiple pages if needed (up to 5 pages)
                            let foundRole = null;
                            for (let page = 1; page <= 5 && !foundRole; page++) {
                                const usersResponse = await ApiService.getUsers(null, null, page, null);
                                const userInList = usersResponse.data.find(u => u[0] === viewedUser);
                                if (userInList && userInList[4]) {
                                    foundRole = userInList[4];
                                    console.log(`Found role from users list (page ${page}):`, foundRole);
                                    break;
                                }
                            }
                            if (foundRole) {
                                userRole = foundRole;
                            }
                        } catch (err) {
                            console.error('Error fetching role from users list:', err);
                        }
                    }
                    
                    // Normalize role to uppercase (ADMIN, USER) or default to USER
                    userRole = (userRole || 'USER').toString().toUpperCase();
                    console.log('Final extracted and normalized role:', userRole);
                    
                    // Mapowanie płci z API na format wyświetlania
                    const sexMapping = {
                        'MALE': 'Mężczyzna',
                        'FEMALE': 'Kobieta',
                        'OTHER': 'Inna'
                    };



                    // Pobierz dane lokalizacji, jeśli są dostępne koordynaty
                    let gpsPointString = '';
                    if (responseData.profile && responseData.profile.geoCoordinates) {
                        try {
                            const geoCodingResponse = await ApiService.geoCoding(
                                responseData.profile.geoCoordinates.longitude,
                                responseData.profile.geoCoordinates.latitude
                            );
                            gpsPointString = geoCodingResponse.locationName || '';
                            console.log('Pobrana lokalizacja:', gpsPointString);
                        } catch (geoError) {
                            console.error('Błąd podczas geokodowania:', geoError);
                        }
                    }

                    
                    // Przygotowanie tablicy zdjęć
                    const otherPhotos = responseData.profile && responseData.profile.otherPhotosUrls 
                        ? [...responseData.profile.otherPhotosUrls] 
                        : [];

                    // Pobieranie danych sportów pojedynczo dla każdego sportSkill
                    const sportPromises = [];
                    const sportSkills = responseData.profile?.sportSkills || [];

                    // Tworzymy tablicę promises dla każdego sportu
                    for (const skill of sportSkills) {
                        sportPromises.push(ApiService.getSportById(skill.sportId));
                    }

                    // Pobieramy dane o najczęściej uprawianym sporcie (jeśli istnieje)
                    if (responseData.profile?.mostPracticedSport) {
                        sportPromises.push(ApiService.getSportById(responseData.profile.mostPracticedSport));
                    }

                    // Czekamy na wszystkie zapytania
                    const sportsData = await Promise.all(sportPromises);

                    // Tworzymy mapę sportów na podstawie otrzymanych danych
                    const sportsMap = {};
                    let mostPracticedSportData = null;

                    // Jeśli istnieje mostPracticedSport, to ostatni element w sportsData to jego dane
                    if (responseData.profile?.mostPracticedSport) {
                        mostPracticedSportData = sportsData.pop();
                        sportsMap[responseData.profile.mostPracticedSport] = mostPracticedSportData;
                    }

                    // Mapujemy pozostałe dane sportów
                    sportSkills.forEach((skill, index) => {
                        if (sportsData[index]) {
                            sportsMap[skill.sportId] = sportsData[index];
                        }
                    });

                    // Mapowanie umiejętności sportowych
                    const otherSports = [];
                    if (responseData.profile && responseData.profile.sportSkills) {
                        responseData.profile.sportSkills.forEach(skill => {
                            const sportData = sportsMap[skill.sportId];

                            if (sportData) {
                                otherSports.push({
                                    icon: sportData.iconUrl || `https://api-dev.teamme.pl/images/default-sport-icon`,
                                    name: sportData.name || `Sport ID: ${skill.sportId}`,
                                    score: skill.skillLevel || 0
                                });
                            }
                        });
                    }

                    // Określenie najczęściej uprawianego sportu
                    const mostPracticedSportName = mostPracticedSportData ? mostPracticedSportData.name : '';

                    // Aktualizuj formData z wszystkimi danymi
                    setFormData({
                        // Dane podstawowe
                        id: responseData.profile ? responseData.profile.userId : '',
                        first_name: responseData.profile ? responseData.profile.first_name : '',
                        createdAt: new Date().toISOString().replace('T', ' ').substring(0, 19), // Brak daty utworzenia w API
                        email: responseData.email || '',
                        phoneNumber: responseData.phoneNumber || 'Brak numeru telefonu',
                        password: '***********', // Zawsze ukryte
                        accountPlan: responseData.profile?.accountPlan || 'BASIC',        // NEW
                        lastLogin: responseData.lastLoginAt || '',
                        role: userRole, // Use extracted and normalized role

                        // Dane dodatkowe
                        sex: responseData.profile ? sexMapping[responseData.profile.sex] || '' : '',
                        gpsPoint: gpsPointString,
                        yearOfBirth: responseData.profile ? responseData.profile.yearOfBirth?.toString() || '' : '',
                        profilePhoto: responseData.profile ? responseData.profile.profilePhotoUrl || '' : '',
                        otherPhotos: otherPhotos,

                        // Dyscypliny
                        mostPracticedSport: mostPracticedSportName,
                        otherSports: otherSports,

                        // Opinie - brak danych w responseData
                        avgScore: 0,
                        numberOfOpinions: 1250,
                        opinions: [
                            [1,
                                '22.01.2024',
                                'Ktoś',
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'
                                }}>
                                    {[...Array(5)].map((_, index) => (
                                        <StarFilled />
                                    ))}
                                    {[...Array(5 - 5)].map((_, index) => (
                                        <StarEmpty />
                                    ))}
                                </div>,
                            ],
                            [2,
                                '22.01.2024',
                                'Ktoś',
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'

                                }}>
                                    {[...Array(3)].map((_, index) => (
                                        <StarFilled />
                                    ))}
                                    {[...Array(5 - 3)].map((_, index) => (
                                        <StarEmpty />
                                    ))}
                                </div>
                            ]],

                        // Płatności - brak danych w responseData
                        payments: [],
                    });
                    try {
                        const hasBlockedResponse = await ApiService.getHasBlocked(viewedUser);
                        console.log('Otrzymane dane z API:', hasBlockedResponse);
                        setBlocked(hasBlockedResponse);
                    } catch (error) {
                        console.error('Błąd:', error);
                    }
                } catch (error) {
                    console.error('Błąd podczas pobierania danych użytkownika:', error);
                }
            };
            
            fetchUserData();
        }

        setIsLoading(false); // Włącz loader na początku

    }, [viewedUser, refresh]);



    useEffect(() => {
    const isValid = formData.first_name.trim() !== '';
    setIsSubmitDisabled(!isValid);
  }, [formData, modalViewActualTab]); // Monitoruj zmiany w `formData`

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let iconUrl = null;

      if (formData.thumbnail) {
        const uploadedImagePath = await ApiService.uploadImage(formData.thumbnail);
        iconUrl = uploadedImagePath;
      }

      const sportData = {
        name: formData.name,
        nameEng: formData.englishName,
        iconUrl: iconUrl,
      };

      const response = await ApiService.addNewSport(sportData);
      console.log('Nowy sport został dodany:', response);

      dispatch(toggleEditModal());
      dispatch(toggleNeedRefresh());
    } catch (error) {
      console.error('Błąd podczas dodawania nowego sportu:', error);
    }
  };

  const handleCloseModal = () => {
    dispatch(toggleEditModal());
  };

  const handleToggleRole = async () => {
    if (!formData.id) return;
    
    // Get current role - check both formData.role and uppercase/lowercase variations
    const currentRole = (formData.role || 'USER').toUpperCase();
    const newRole = currentRole === 'ADMIN' ? 'USER' : 'ADMIN';
    
    const roleText = newRole === 'ADMIN' ? 'Administratora' : 'Użytkownika';
    const actionText = currentRole === 'ADMIN' ? 'usunąć uprawnienia administratora' : 'nadać uprawnienia administratora';
    
    if (!window.confirm(`Czy na pewno chcesz ${actionText}?`)) {
      return;
    }
    
    setIsLoading(true);
    try {
      const updatedUser = await ApiService.updateUserRole(formData.id, newRole);
      alert(`Rola użytkownika została zmieniona na ${roleText}.`);
      
      // Update formData with the new role from API response
      if (updatedUser && updatedUser.role) {
        setFormData(prev => ({ ...prev, role: updatedUser.role }));
      } else {
        // Fallback: update manually
        setFormData(prev => ({ ...prev, role: newRole }));
      }
      
      // Refresh user data to get latest from API
      setRefresh(!refresh);
    } catch (error) {
      console.error('Błąd podczas zmiany roli:', error);
      alert('Nie udało się zmienić roli użytkownika.');
    } finally {
      setIsLoading(false);
    }
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Fetch per-user statistics when Statystyki tab is selected
  useEffect(() => {
    if (modalViewActualTab !== 'Statystyki' || !viewedUser) return;
    let cancelled = false;
    setStatsLoading(true);
    setStatsError(null);
    ApiService.getPerUserStatistics(viewedUser)
      .then((data) => {
        if (!cancelled) setUserStats(data);
      })
      .catch((err) => {
        if (!cancelled) {
          setStatsError(err?.response?.data?.message || err?.message || 'Błąd ładowania statystyk');
          setUserStats(null);
        }
      })
      .finally(() => {
        if (!cancelled) setStatsLoading(false);
      });
    return () => { cancelled = true; };
  }, [modalViewActualTab, viewedUser]);

  const handleImageNavigation = (direction) => {
    if (direction === 'next' && currentImageIndex + 3 < formData.otherPhotos.length) {
      setCurrentImageIndex(prevIndex => prevIndex + 3);
    } else if (direction === 'prev' && currentImageIndex > 0) {
      setCurrentImageIndex(prevIndex => Math.max(0, prevIndex - 3));
    }
  };

  return (
    <Modal isOpen={isModalOpen} onClose={handleCloseModal} className={blocked === true ? "modal-content-3" : "modal-content-2" }>

        {isLoading && <Spinner size="medium" color="#007bff" />}

        <h2>Użytkownik {blocked === true ? " - zablokowany" : "" }</h2>
        <div className="vu-head">
            <div className="vu-head__left">
                <div className="vu-head__meta">
                    {formData.id && <span>(ID {formData.id})</span>}
                    {formData.lastLogin && (
                        <span className="vu-head__divider">•</span>
                    )}
                    {formData.lastLogin && (
                        <span>Ostatnie logowanie: {formData.lastLogin}</span>
                    )}
                </div>

                <div className="vu-head__title">
                    <span className="vu-head__email">{formData.email}</span>
                    {formData.first_name && (
                        <span className="vu-head__name">
          ({formData.first_name}{/* add last name if you keep it */})
        </span>
                    )}
                    <span className={`vu-plan vu-plan--${(formData.accountPlan || 'BASIC').toLowerCase()}`}>
        {(formData.accountPlan || 'BASIC').toUpperCase()}
      </span>
                </div>
            </div>

            <div className="vu-head__right">
                <button type="button" className="vu-btn vu-btn--primary">
                    Przydziel abonament
                </button>
            </div>
        </div>

        {/* TABS */}
        <div className="vu-tabs">
            {modalViewTabs.map((tab, index) => {
                const active = modalViewActualTab === tab;
                return (
                    <button
                        key={tab}
                        className={`vu-tab ${active ? 'is-active' : ''}`}
                        onClick={() => dispatch(setModalViewActualTab(tab))}
                    >
                        {tab}
                    </button>
                );
            })}
        </div>
      {/*------------------------------------------------------------*/}
        {modalViewActualTab === "Dane podstawowe" && (
            <div className="vu-grid">
                {/* ID */}
                <div className="vu-row">
                    <div className="vu-row__label">ID</div>
                    <div className="vu-row__value">{formData.id || '—'}</div>
                    <div className="vu-row__action" />
                </div>

                {/* Uprawnienia/Rola */}
                <div className="vu-row">
                    <div className="vu-row__label">Uprawnienia</div>
                    <div className="vu-row__value">{(formData.role || 'USER').toUpperCase()}</div>
                    <div className="vu-row__action">
                        <button
                            type="button"
                            className="vu-btn vu-btn--ghost"
                            onClick={handleToggleRole}
                            disabled={isLoading}
                        >
                            {(formData.role || 'USER').toUpperCase() === 'ADMIN' 
                                ? 'Usuń uprawnienia admina' 
                                : 'Nadaj uprawnienia admina'}
                        </button>
                    </div>
                </div>

                {/* Imię */}
                <div className="vu-row">
                    <div className="vu-row__label">Imię</div>
                    <div className="vu-row__value">{formData.first_name || '—'}</div>
                    <div className="vu-row__action" />
                </div>

                {/* Nazwisko (jeśli trzymasz) */}
                {/* <div className="vu-row">
      <div className="vu-row__label">Nazwisko</div>
      <div className="vu-row__value">{formData.last_name || '—'}</div>
      <div className="vu-row__action" />
    </div> */}

                {/* Email + akcja */}
                <div className="vu-row">
                    <div className="vu-row__label">Adres e-mail</div>
                    <div className="vu-row__value">{formData.email || '—'}</div>
                    <div className="vu-row__action">
                        <button
                            type="button"
                            className="vu-btn vu-btn--ghost"
                            onClick={handleCloseModal /* TODO: replace with your action */}
                        >
                            Wiadomość z resetem hasła
                        </button>
                    </div>
                </div>

                {/* Zdjęcie profilowe */}
                <div className="vu-row vu-row--image">
                    <div className="vu-row__label">Zdjęcie profilowe</div>
                    <div className="vu-row__value">
                        <div className="vu-photo">
                            {formData.profilePhoto ? (
                                <img src={formData.profilePhoto} alt="Profil" />
                            ) : (
                                <div className="vu-photo__placeholder" />
                            )}
                        </div>
                    </div>
                    <div className="vu-row__action" />
                </div>
            </div>
        )}
      { modalViewActualTab === "Statystyki" && (
        <div className="vu-stats">
          {statsLoading && (
            <div className="vu-stats-loading">
              <Spinner size="medium" color="#2F80ED" />
              <span>Ładowanie statystyk…</span>
            </div>
          )}
          {statsError && !statsLoading && (
            <div className="vu-stats-error">{statsError}</div>
          )}
          {userStats && !statsLoading && (
            <div className="vu-grid">
              <div className="vu-stats-section-title">Konto</div>
              <div className="vu-row">
                <div className="vu-row__label">Plan</div>
                <div className="vu-row__value">{userStats.account?.accountPlan ?? '—'}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">W systemie od</div>
                <div className="vu-row__value">
                  {userStats.account?.memberSince
                    ? new Date(userStats.account.memberSince).toLocaleDateString('pl-PL', { dateStyle: 'medium' })
                    : '—'}
                </div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Powiadomienia włączone</div>
                <div className="vu-row__value">{userStats.account?.notificationsEnabled ? 'Tak' : 'Nie'}</div>
                <div className="vu-row__action" />
              </div>

              <div className="vu-stats-section-title">Notatki (dziennik)</div>
              <div className="vu-row">
                <div className="vu-row__label">Wszystkie notatki</div>
                <div className="vu-row__value">{userStats.notes?.totalNotes ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Notatki w tym miesiącu</div>
                <div className="vu-row__value">{userStats.notes?.notesThisMonth ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Śr. notatek/dzień (ten miesiąc)</div>
                <div className="vu-row__value">{(userStats.notes?.averageNotesPerDayThisMonth ?? 0).toFixed(2)}</div>
                <div className="vu-row__action" />
              </div>

              <div className="vu-stats-section-title">Faktury</div>
              <div className="vu-row">
                <div className="vu-row__label">Wszystkie faktury</div>
                <div className="vu-row__value">{userStats.invoices?.totalInvoices ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Faktury w tym miesiącu</div>
                <div className="vu-row__value">{userStats.invoices?.invoicesThisMonth ?? 0}</div>
                <div className="vu-row__action" />
              </div>

              <div className="vu-stats-section-title">Kontrola pojazdu</div>
              <div className="vu-row">
                <div className="vu-row__label">Wszystkie checklisty</div>
                <div className="vu-row__value">{userStats.vehicleCheck?.totalChecklists ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Otwarte / Zamknięte</div>
                <div className="vu-row__value">{userStats.vehicleCheck?.openChecklists ?? 0} / {userStats.vehicleCheck?.closedChecklists ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Ukończone (%)</div>
                <div className="vu-row__value">{(userStats.vehicleCheck?.percentCompleted ?? 0).toFixed(1)}%</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Śr. dni do zamknięcia</div>
                <div className="vu-row__value">
                  {userStats.vehicleCheck?.averageDaysToClose != null
                    ? Number(userStats.vehicleCheck.averageDaysToClose).toFixed(2)
                    : '—'}
                </div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Aktywna sesja checklisty</div>
                <div className="vu-row__value">{userStats.vehicleCheck?.hasActiveSession ? 'Tak' : 'Nie'}</div>
                <div className="vu-row__action" />
              </div>

              <div className="vu-stats-section-title">Tygodnie pracy</div>
              <div className="vu-row">
                <div className="vu-row__label">Wszystkie</div>
                <div className="vu-row__value">{userStats.workWeeks?.totalWorkWeeks ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">W tym miesiącu</div>
                <div className="vu-row__value">{userStats.workWeeks?.workWeeksThisMonth ?? 0}</div>
                <div className="vu-row__action" />
              </div>

              <div className="vu-stats-section-title">Czas pracy (timesheets)</div>
              <div className="vu-row">
                <div className="vu-row__label">Dzienne / Tygodniowe</div>
                <div className="vu-row__value">{userStats.timesheets?.totalDaily ?? 0} / {userStats.timesheets?.totalWeekly ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">W tym miesiącu (dzienne / tygodniowe)</div>
                <div className="vu-row__value">{userStats.timesheets?.dailyThisMonth ?? 0} / {userStats.timesheets?.weeklyThisMonth ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Wysłane (dzienne / tygodniowe)</div>
                <div className="vu-row__value">{userStats.timesheets?.sentDaily ?? 0} / {userStats.timesheets?.sentWeekly ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">% wysłanych</div>
                <div className="vu-row__value">{(userStats.timesheets?.percentSent ?? 0).toFixed(1)}%</div>
                <div className="vu-row__action" />
              </div>

              <div className="vu-stats-section-title">Pozostałe</div>
              <div className="vu-row">
                <div className="vu-row__label">Nieprzeczytane powiadomienia</div>
                <div className="vu-row__value">{userStats.notifications?.unseenCount ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Artykuły (encyklopedia)</div>
                <div className="vu-row__value">{userStats.articles?.totalArticles ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Pojazdy</div>
                <div className="vu-row__value">{userStats.misc?.vehiclesCount ?? 0}</div>
                <div className="vu-row__action" />
              </div>
              <div className="vu-row">
                <div className="vu-row__label">Zdjęcia</div>
                <div className="vu-row__value">{userStats.misc?.imagesCount ?? 0}</div>
                <div className="vu-row__action" />
              </div>
            </div>
          )}
        </div>
      ) }



        {<div className="modal-margin-top-20">
            <button className="buttons-modal-appearance-almost-white" type="button" onClick={handleCloseModal}>
                Zamknij
            </button>
            {blocked === false ?
            <button className="buttons-modal-appearance-almost-white" type="button" onClick={handleZablokujOblokuj}>Zablokuj</button> : <button className="buttons-modal-appearance-almost-white" type="button" onClick={handleZablokujOblokuj}>Odblokuj</button>}

            </div>}

    </Modal>
  );
}

export default ViewUser;